import React from 'react';
import { LISTING_BOOSTED_BADGE_IMAGE } from '../../../../utils/constants';

const BoostBadge: React.FC = () => {
  return (
    <img
      src={LISTING_BOOSTED_BADGE_IMAGE}
      alt="Boosted"
      style={{
        position: 'absolute',
        top: '15px',
        right: '15px',
        width: 'auto',
        height: '20px',
      }}
    />
  );
};

export default BoostBadge;
